import {styled} from "@mui/material/styles"

export const Li = styled("li")`
    list-style: none;
    margin: 0.625rem;

    a {
        display: flex;
        padding: 0;
    }

    a:active,
    a:hover,
    a:focus,
    a:active,
    a:hover,
    a:focus,
    a:visited,
    a {
        color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.textColor};
    }
`
